import { render, staticRenderFns } from "./money-input.vue?vue&type=template&id=448ac9f7&scoped=true&"
import script from "./money-input.vue?vue&type=script&lang=ts&"
export * from "./money-input.vue?vue&type=script&lang=ts&"
import style0 from "./money-input.vue?vue&type=style&index=0&id=448ac9f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ac9f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
